





























































































import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    products: {
      required: true,
      type: Array,
    },
  },
})
